import clsx from 'clsx';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import { Link } from '~components/generic/elements/Link/Link';
import { ModuleAttachments } from '~components/generic/module-attachments/ModuleAttachments';
import ResponsiveBackgroundContainer from '~components/generic/responsive-background/ResponsiveBackgroundContainer';
import { IEntityComponentProps } from '~interfaces/props';
import { getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';

export const ModuleSlimLink = ({ data, editing, className, onChange, isEditing }: IEntityComponentProps) => {
  if (!data) {
    return null;
  }
  const imageId = getRelatedEntityIds(data, 'field_bg_image')[0];
  const colorVariant = parseInt(data.attributes.field_link_color, 10);
  const layoutVariant = parseInt(data.attributes.field_slim_link_variant, 10);
  const clsModule = clsx({ ...className.module, 'u-color-white': colorVariant === 1 }, 'u-relative');
  const clsContainer: any = {
    ...className?.container,
    'px-0': true,
    relative: true,
    'c-module--type--slim-link__background': true,
  };
  const clsTextColumn = clsx({
    col: true,
    'col-xl-6': true,
    'offset-xl-6': layoutVariant === 0,
  });
  const clsButton = clsx({
    'c-button': true,
    'u-margin-bottom-md': true,
    'c-button--lightest': colorVariant === 1,
    'c-button--dark': colorVariant === 2 || isNaN(colorVariant),
  });

  const linkId: string = data.attributes.field_link_internal;
  const linkUrl: string = data.attributes.field_link_external?.uri;
  const linkText: string = data.attributes.field_link_text;
  const fieldHideTitle = data.attributes.field_hide_title;
  const fieldTitleValue = data.attributes.field_title?.value || '';
  const fieldHideText = data.attributes.field_hide_text;
  const fieldTextValue: string = data.attributes.field_text?.value || '';

  return (
    <div className={clsModule} id={getModuleUrlIdFromData(data.id, data.type)}>
      <ResponsiveBackgroundContainer
        className={clsContainer}
        entityId={imageId}
        proportions="original"
        placeholder={!imageId && isEditing}
      >
        <div className="c-module--type--slim-link__background u-padding-top-md u-padding-bottom-lg u-padding-horizontal-lg">
          <div className="row c-module__header relative">
            <ModuleAttachments data={data} />
          </div>
          <div className="row c-module__content">
            <div className={clsTextColumn}>
              <EditableField
                hide={fieldHideTitle}
                entityType={data.type}
                fieldName="attributes.field_title.value"
                data={fieldTitleValue}
                editing={editing}
                onChange={onChange}
              />
              <div className="u-margin-vertical-sm o-field-text">
                <EditableField
                  hide={fieldHideText}
                  entityType={data.type}
                  fieldName="attributes.field_text.value"
                  data={fieldTextValue}
                  editing={editing}
                  onChange={onChange}
                />
              </div>
              {(linkId || linkUrl) && <Link id={linkId} url={linkUrl} label={linkText} className={clsButton} />}
            </div>
          </div>
        </div>
      </ResponsiveBackgroundContainer>
    </div>
  );
};

export default ModuleSlimLink;
